import createIcon from '../../createIcon';

/**
 * @component @name Outlet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk05IDEyQzguNDUgMTIgOCAxMS41NSA4IDExVjhDOCA3LjQ1IDguNDUgNyA5IDdDOS41NSA3IDEwIDcuNDUgMTAgOFYxMUMxMCAxMS41NSA5LjU1IDEyIDkgMTJaTTE0IDE4SDEwVjE2QzEwIDE0LjkgMTAuOSAxNCAxMiAxNEMxMy4xIDE0IDE0IDE0LjkgMTQgMTZWMThaTTE2IDExQzE2IDExLjU1IDE1LjU1IDEyIDE1IDEyQzE0LjQ1IDEyIDE0IDExLjU1IDE0IDExVjhDMTQgNy40NSAxNC40NSA3IDE1IDdDMTUuNTUgNyAxNiA3LjQ1IDE2IDhWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Outlet = createIcon('Outlet', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9 12C8.45 12 8 11.55 8 11V8C8 7.45 8.45 7 9 7C9.55 7 10 7.45 10 8V11C10 11.55 9.55 12 9 12ZM14 18H10V16C10 14.9 10.9 14 12 14C13.1 14 14 14.9 14 16V18ZM16 11C16 11.55 15.55 12 15 12C14.45 12 14 11.55 14 11V8C14 7.45 14.45 7 15 7C15.55 7 16 7.45 16 8V11Z',
      key: '147x2p',
    },
  ],
]);

export default Outlet;
